import { render, staticRenderFns } from "./ServicesSelect.vue?vue&type=template&id=20a65306"
import script from "./ServicesSelect.vue?vue&type=script&lang=js"
export * from "./ServicesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports